let locales = {
    announcementNoteDetail_detail: `Detalle`,
}

export default locales;